import { render, staticRenderFns } from "./Template02.vue?vue&type=template&id=8f80785a&scoped=true&"
import script from "./Template02.vue?vue&type=script&lang=js&"
export * from "./Template02.vue?vue&type=script&lang=js&"
import style0 from "./Template02.vue?vue&type=style&index=0&id=8f80785a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f80785a",
  null
  
)

export default component.exports